export const SUPPLIES_FREE_LABELS_ANNOUNCEMENT_CUTOFF =
  Temporal.ZonedDateTime.from("2026-08-01T00:00:00[America/Denver]");

export function isBeforeSuppliesFreeLabelsAnnouncementCutoff(
  now: Temporal.Instant,
): boolean {
  return (
    Temporal.Instant.compare(
      now,
      SUPPLIES_FREE_LABELS_ANNOUNCEMENT_CUTOFF.toInstant(),
    ) < 0
  );
}
